import { initPerfume } from 'perfume.js';
import { type RouteLocationNormalizedLoaded } from '#vue-router';
import { stringify } from 'qs';
import {
    WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsitePerformanceMetricsPost,
    type WebSitePerformanceMetric,
} from '@clients/TrackingApi';

const METRIC_BATCH_MILLIS = 1000;
export default defineNuxtPlugin(({ vueApp }) => {
    let metricsQueue: WebSitePerformanceMetric[] = [];
    let timeout: NodeJS.Timeout | number | undefined;
    function start() {
        if (timeout) {
            return;
        }
        timeout = setTimeout(() => {
            if (!metricsQueue.length) {
                return;
            }
            const clone = [...metricsQueue];
            WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsitePerformanceMetricsPost(
                {
                    collectWebsitePerformanceMetricInputDto: {
                        websitePerformanceMetrics: clone,
                    },
                }
            ).catch();
            metricsQueue = [];
            timeout = undefined;
        }, METRIC_BATCH_MILLIS);
    }
    const authStore = useAuthStore();
    initPerfume({
        elementTiming: false,
        resourceTiming: false,
        analyticsTracker: options => {
            if (typeof options.data !== 'number') {
                return;
            }
            const currentRoute = (
                vueApp.$nuxt.$router as {
                    currentRoute: Ref<RouteLocationNormalizedLoaded>;
                }
            )?.currentRoute;
            metricsQueue.push({
                pageAddressWithoutQueryString:
                    currentRoute?.value?.matched?.[
                        currentRoute.value.matched.length - 1
                    ].path,
                queryString: stringify(currentRoute.value.query),
                playerId: authStore.uuid ?? undefined,
                webVitals: [
                    {
                        key: options.metricName,
                        value: options.data,
                    },
                ],
                sessionId: authStore.sessionId,
            });
            start();
        },
    });
});
